module.exports = __webpack_public_path__ + "img/r3.61905f51.jpg";